import { potsService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

// The company pot is the single ACTIVE pot related to the company (holds the company's points).
const useFetchCompanyPot = (companyId?: string) => {
  return useQuery({
    queryKey: ['fetchCompanyPot', companyId],
    queryFn: async () => {
      const response = await potsService.fetchPots({
        companyIds: [companyId || ''],
        relatedType: ['COMPANY'],
        status: ['ACTIVE'],
        page: 0,
        size: 1,
      });

      return response.list[0] ?? null;
    },
    enabled: !!companyId,
  });
};

export default useFetchCompanyPot;
